import React from "react";
import WarningIcon from "./warningIcon";
import { useAppSelector } from "../redux/hooks";

interface ErrorMessageProps {
  message?: string;
  className?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, className }) => {
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);

  if (!message) return null;

  return (
    <div
      className={`${className}`}
      style={{
        color: currentTheme === "light" ? "#d91734" : "#F16A81",
      }}
    >
      <WarningIcon /> {message}
    </div>
  );
};

export default ErrorMessage;
